<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import ActivityComponent from './ActivityComponent.vue'

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, actionType } = this.activity
      const creator = user?.uuid === this.self.uuid ? this.$t('You') : user.name
      let action = ''

      switch (actionType) {
      case 'task.comment_deleted':
        action = 'deleted'
        break
      case 'task.comment_edited':
        action = 'updated'
        break
      default:
        action = 'added'
      }

      return `${creator} ${action} a comment.`
    },
  },
}
</script>
